import { Button } from "primereact/button";
import Select from "../../../components/input/Select";
import Input from "../../../components/input/Input";

export const FiltersPayment = ({
  handleSubmit,
  onSubmit,
  isLoadingEnterprises,
  enterprise,
  selectedEnterprise,
  setSelectedEnterprise,
  control,
  errors,
  loading,
}) => {
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} className="mb-4">
        <div className="row align-items-end py-2">
          <div className="col-xl-3 mt-3 mt-xl-0">
            <Select
              name="enterprise_id"
              label={isLoadingEnterprises ? "Carregando..." : "Empreendimento *"}
              options={enterprise}
              optionLabel="label"
              optionValue="value"
              value={selectedEnterprise}
              onChange={setSelectedEnterprise}
              isRequired
              disabled={isLoadingEnterprises}
              control={control}
              className="w-100"
              errors={errors}
            />
          </div>
          <div className="col-xl-3 mt-3 mt-xl-0">
            <Input
              name="sale_id"
              errors={errors}
              control={control}
              isRequired
              label="Número Ficha *"
            />
          </div>
          <div className="col-xl-2 d-flex ">
            <Button
              className="p-button-primary w-100 mt-3 mt-xl-0"
              icon={loading ? "pi pi-spinner pi-spin" : "pi pi-search"}
              type="submit"
              disabled={loading}
              loading={loading}
            />
          </div>
        </div>
      </form>
    </>
  );
};
